import React from "react";
import { Link } from "react-router-dom";
import { Seo } from "../components/Seo";

export default function NotFound() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-24 text-center" data-testid="not-found-page" style={{ fontFamily: "'Bricolage Grotesque',ui-sans-serif,system-ui,sans-serif" }}>
      <Seo title="Page introuvable" noindex />
      <p className="text-sm font-bold uppercase tracking-[0.12em] text-[#A8410F]">Erreur 404</p>
      <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-[#2B1A12]">Cette page s'est émiettée.</h1>
      <p className="mt-4 text-[#6E5546]">Elle n'existe pas ou plus. Voici de quoi te remettre en appétit :</p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link to="/" data-testid="nf-home" className="px-6 py-3 rounded-full bg-[#B44A16] text-white font-bold hover:bg-[#A8410F] transition-colors">Accueil</Link>
        <Link to="/cookies" data-testid="nf-cookies" className="px-6 py-3 rounded-full border-2 border-[#2B1A12] text-[#2B1A12] font-bold hover:bg-[#2B1A12] hover:text-white transition-colors">Nos cookies</Link>
        <Link to="/composer-ma-box" data-testid="nf-box" className="px-6 py-3 rounded-full border-2 border-[#2B1A12] text-[#2B1A12] font-bold hover:bg-[#2B1A12] hover:text-white transition-colors">Composer ma box</Link>
      </div>
    </div>
  );
}
